/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconBatteryBlack: {
  name: 'battery_black';
  data: string;
} = {
  name: 'battery_black',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M197.279 220.208c-1.135 0-4.109.952-4.109 2.129v2.129h-4.071c-2.27 0-4.109 1.904-4.109 4.258V254.2c0 2.355 1.839 4.258 4.109 4.258h20.47c2.27 0 4.109-1.904 4.109-4.258v-25.475c0-2.355-1.839-4.258-4.109-4.258h-4.071v-2.129c0-1.177-2.974-2.129-4.109-2.129h-4.11v-.001zm2.054 8.517v10.608h8.18l-8.18 14.867v-10.608h-8.18l8.18-14.867z" transform="matrix(15 0 0 15 -2684 -3284)"/></svg>`,
};
